export enum ProposalTileSortParameter {
  CREATION_DATE = 'creationDate',
  RISK_DATE_BEGIN = 'riskDateBegin',
  RISK_DATE_END = 'riskDateEnd',
  DEADLINE = 'deadline',
  INSURED_AMOUNT = 'insuredAmount',
  COVERAGE = 'coverage'
}
